/**
 * @file Openapi Schema
 * @version 0.1.0
 * @author Openapi Generator src_common/server/node_task/run_app/openapi/openapi.ts
 * @date 2026-06-15T11:16:35.956Z
 *
 * Details:
 * --- File generated by generator do not modify this file manually ---
 */

import { z } from 'zod';


// #/components/schemas/complianceCurrency
export const ComplianceCurrencyZod = z.union([z.literal('EUR'), z.literal('GBP'), z.literal('XTS')]);
export type ComplianceCurrencyType = z.TypeOf<typeof ComplianceCurrencyZod>;


// #/components/schemas/complianceLicenseAccountConfigInner
export const ComplianceLicenseAccountConfigInnerZod = z.object({
    currency: ComplianceCurrencyZod.optional(),
    maxSingleWithdrawalTrigger: z.string().optional(),
    maxSingleDepositTrigger: z.string().optional(),
    maxTotalWithdrawalTriggerUnderThreshold: z.string().optional(),
    maxTotalWithdrawalTriggerOverThreshold: z.string().optional(),
    maxTotalDepositTriggerUnderThreshold: z.string().optional(),
    maxTotalDepositTriggerOverThreshold: z.string().optional(),
    drMaxTotalWithdrawalTriggerUnderThreshold: z.string().optional(),
    drMaxTotalWithdrawalTriggerOverThreshold: z.string().optional(),
    drMaxTotalDepositTriggerUnderThreshold: z.string().optional(),
    drMaxTotalDepositTriggerOverThreshold: z.string().optional(),
});
export type ComplianceLicenseAccountConfigInnerType = z.TypeOf<typeof ComplianceLicenseAccountConfigInnerZod>;


// #/components/schemas/complianceLicenseAccountConfigResponse
export const ComplianceLicenseAccountConfigResponseZod = z.object({
    config: z.array(ComplianceLicenseAccountConfigInnerZod),
});
export type ComplianceLicenseAccountConfigResponseType = z.TypeOf<typeof ComplianceLicenseAccountConfigResponseZod>;


// #/components/schemas/complianceApiError
export const ComplianceApiErrorZod = z.object({
    code: z.number(),
    message: z.string(),
});
export type ComplianceApiErrorType = z.TypeOf<typeof ComplianceApiErrorZod>;


// #/components/schemas/complianceApiErrorResponse
export const ComplianceApiErrorResponseZod = z.object({
    error: ComplianceApiErrorZod,
});
export type ComplianceApiErrorResponseType = z.TypeOf<typeof ComplianceApiErrorResponseZod>;


// #/components/schemas/complianceLicenseAccountConfigInfoUpdateRequest
export const ComplianceLicenseAccountConfigInfoUpdateRequestZod = z.object({
    currency: ComplianceCurrencyZod,
    maxSingleWithdrawalTrigger: z.string().optional(),
    maxSingleDepositTrigger: z.string().optional(),
    maxTotalWithdrawalTriggerUnderThreshold: z.string().optional(),
    maxTotalWithdrawalTriggerOverThreshold: z.string().optional(),
    maxTotalDepositTriggerUnderThreshold: z.string().optional(),
    maxTotalDepositTriggerOverThreshold: z.string().optional(),
    drMaxTotalWithdrawalTriggerUnderThreshold: z.string().optional(),
    drMaxTotalWithdrawalTriggerOverThreshold: z.string().optional(),
    drMaxTotalDepositTriggerUnderThreshold: z.string().optional(),
    drMaxTotalDepositTriggerOverThreshold: z.string().optional(),
});
export type ComplianceLicenseAccountConfigInfoUpdateRequestType = z.TypeOf<typeof ComplianceLicenseAccountConfigInfoUpdateRequestZod>;


// #/components/schemas/complianceEmptyResponse
export const ComplianceEmptyResponseZod = z.unknown();
export type ComplianceEmptyResponseType = z.TypeOf<typeof ComplianceEmptyResponseZod>;


// #/components/schemas/complianceLicenseConfigResponseInner
export const ComplianceLicenseConfigResponseInnerZod = z.object({
    currency: ComplianceCurrencyZod,
    maxSingleWithdrawalTrigger: z.string(),
    maxSingleDepositTrigger: z.string(),
    maxTotalWithdrawalTriggerUnderThreshold: z.string(),
    maxTotalWithdrawalTriggerOverThreshold: z.string(),
    maxTotalDepositTriggerUnderThreshold: z.string(),
    maxTotalDepositTriggerOverThreshold: z.string(),
    drMaxTotalWithdrawalTriggerUnderThreshold: z.string(),
    drMaxTotalWithdrawalTriggerOverThreshold: z.string(),
    drMaxTotalDepositTriggerUnderThreshold: z.string(),
    drMaxTotalDepositTriggerOverThreshold: z.string(),
});
export type ComplianceLicenseConfigResponseInnerType = z.TypeOf<typeof ComplianceLicenseConfigResponseInnerZod>;


// #/components/schemas/complianceLicenseConfigResponse
export const ComplianceLicenseConfigResponseZod = z.object({
    config: z.array(ComplianceLicenseConfigResponseInnerZod),
});
export type ComplianceLicenseConfigResponseType = z.TypeOf<typeof ComplianceLicenseConfigResponseZod>;


// #/components/schemas/complianceLicenseConfigInfo
export const ComplianceLicenseConfigInfoZod = z.object({
    currency: ComplianceCurrencyZod,
    universe: z.string(),
    maxSingleWithdrawalTrigger: z.string(),
    maxSingleDepositTrigger: z.string(),
    maxTotalWithdrawalTriggerUnderThreshold: z.string(),
    maxTotalWithdrawalTriggerOverThreshold: z.string(),
    maxTotalDepositTriggerUnderThreshold: z.string(),
    maxTotalDepositTriggerOverThreshold: z.string(),
    drMaxTotalWithdrawalTriggerUnderThreshold: z.string(),
    drMaxTotalWithdrawalTriggerOverThreshold: z.string(),
    drMaxTotalDepositTriggerUnderThreshold: z.string(),
    drMaxTotalDepositTriggerOverThreshold: z.string(),
});
export type ComplianceLicenseConfigInfoType = z.TypeOf<typeof ComplianceLicenseConfigInfoZod>;


// #/components/schemas/complianceFeatureFilter
export const ComplianceFeatureFilterZod = z.union([z.literal('SelfExclusion'), z.literal('Gamstop')]);
export type ComplianceFeatureFilterType = z.TypeOf<typeof ComplianceFeatureFilterZod>;


// #/components/schemas/complianceDateFilter
export const ComplianceDateFilterZod = z.object({
    from: z.string(),
    to: z.string().optional(),
});
export type ComplianceDateFilterType = z.TypeOf<typeof ComplianceDateFilterZod>;


// #/components/schemas/complianceStatusHistoryRequest
export const ComplianceStatusHistoryRequestZod = z.object({
    feature: ComplianceFeatureFilterZod,
    accountId: z.number(),
    limit: z.number(),
    lastId: z.number().optional(),
    dateRange: ComplianceDateFilterZod,
});
export type ComplianceStatusHistoryRequestType = z.TypeOf<typeof ComplianceStatusHistoryRequestZod>;


// #/components/schemas/complianceAuditLog
export const ComplianceAuditLogZod = z.object({
    id: z.number(),
    at: z.string(),
    table_name: z.string(),
    row_id: z.number(),
    trace_id: z.string(),
    actor_id: z.string(),
    request_id: z.string().optional(),
    entrypoint: z.string().optional(),
    reason: z.string().optional(),
    op: z.string(),
    cols_changed: z.array(z.string()).optional(),
    before: z.unknown(),
    after: z.unknown(),
});
export type ComplianceAuditLogType = z.TypeOf<typeof ComplianceAuditLogZod>;


// #/components/schemas/complianceLogs
export const ComplianceLogsZod = z.object({
    rows: z.array(ComplianceAuditLogZod),
});
export type ComplianceLogsType = z.TypeOf<typeof ComplianceLogsZod>;


// #/components/schemas/complianceStaffExcludePayload
export const ComplianceStaffExcludePayloadZod = z.object({
    durationMonths: z.number(),
    accountId: z.number(),
});
export type ComplianceStaffExcludePayloadType = z.TypeOf<typeof ComplianceStaffExcludePayloadZod>;


// #/components/schemas/complianceExclusionInfoSimple
export const ComplianceExclusionInfoSimpleZod = z.object({
    starts: z.string(),
    reactivationAllowedAfter: z.string(),
});
export type ComplianceExclusionInfoSimpleType = z.TypeOf<typeof ComplianceExclusionInfoSimpleZod>;


// #/components/schemas/complianceCustomerStatusExclusionInfoSimple
export const ComplianceCustomerStatusExclusionInfoSimpleZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    status: ComplianceExclusionInfoSimpleZod.optional(),
});
export type ComplianceCustomerStatusExclusionInfoSimpleType = z.TypeOf<typeof ComplianceCustomerStatusExclusionInfoSimpleZod>;


// #/components/schemas/complianceMatchedCustomersStatuses
export const ComplianceMatchedCustomersStatusesZod = z.object({
    createdExclusions: z.array(ComplianceCustomerStatusExclusionInfoSimpleZod),
    existingExclusions: z.array(ComplianceCustomerStatusExclusionInfoSimpleZod),
});
export type ComplianceMatchedCustomersStatusesType = z.TypeOf<typeof ComplianceMatchedCustomersStatusesZod>;


// #/components/schemas/complianceExcludedCustomers
export const ComplianceExcludedCustomersZod = z.object({
    customer: ComplianceCustomerStatusExclusionInfoSimpleZod,
    matched: ComplianceMatchedCustomersStatusesZod.optional(),
});
export type ComplianceExcludedCustomersType = z.TypeOf<typeof ComplianceExcludedCustomersZod>;


// #/components/schemas/complianceExclusionInfoFull
export const ComplianceExclusionInfoFullZod = z.object({
    starts: z.string(),
    reactivationAllowedAfter: z.string(),
    reactivationAfter: z.string().optional(),
});
export type ComplianceExclusionInfoFullType = z.TypeOf<typeof ComplianceExclusionInfoFullZod>;


// #/components/schemas/complianceCustomerStatusExclusionInfoFull
export const ComplianceCustomerStatusExclusionInfoFullZod = z.object({
    accountId: z.number(),
    universe: z.string(),
    status: ComplianceExclusionInfoFullZod.optional(),
});
export type ComplianceCustomerStatusExclusionInfoFullType = z.TypeOf<typeof ComplianceCustomerStatusExclusionInfoFullZod>;


// #/components/schemas/complianceCustomerIdentifier
export const ComplianceCustomerIdentifierZod = z.object({
    accountId: z.number(),
    universe: z.string(),
});
export type ComplianceCustomerIdentifierType = z.TypeOf<typeof ComplianceCustomerIdentifierZod>;


// #/components/schemas/complianceGamstopExclusion
export const ComplianceGamstopExclusionZod = z.union([z.literal('Y'), z.literal('P'), z.literal('N')]);
export type ComplianceGamstopExclusionType = z.TypeOf<typeof ComplianceGamstopExclusionZod>;


// #/components/schemas/complianceDbGamstopRestriction
export const ComplianceDbGamstopRestrictionZod = z.object({
    underExclusion: z.boolean(),
    previouslyPositive: z.boolean(),
    updatedAt: z.string(),
});
export type ComplianceDbGamstopRestrictionType = z.TypeOf<typeof ComplianceDbGamstopRestrictionZod>;


// #/components/schemas/complianceGamstopState
export const ComplianceGamstopStateZod = z.object({
    status: ComplianceGamstopExclusionZod,
    restriction: ComplianceDbGamstopRestrictionZod,
});
export type ComplianceGamstopStateType = z.TypeOf<typeof ComplianceGamstopStateZod>;


// #/components/schemas/complianceGetUserStateResponse
export const ComplianceGetUserStateResponseZod = z.object({
    universe: z.string(),
    accountId: z.number(),
    gamstop: ComplianceGamstopStateZod.optional(),
});
export type ComplianceGetUserStateResponseType = z.TypeOf<typeof ComplianceGetUserStateResponseZod>;


// #/components/schemas/complianceSelfExcludeReportRow
export const ComplianceSelfExcludeReportRowZod = z.object({
    AccountID: z.number(),
    AccountName: z.string(),
    AccountEmail: z.string(),
    Actor: z.string(),
    SeDuration: z.number(),
    SeStart: z.string(),
    SeEnd: z.string(),
});
export type ComplianceSelfExcludeReportRowType = z.TypeOf<typeof ComplianceSelfExcludeReportRowZod>;


// #/components/schemas/complianceSelfExcludeReportResponse
export const ComplianceSelfExcludeReportResponseZod = z.object({
    universe: z.string(),
    startDate: z.string(),
    endDate: z.string(),
    values: z.array(ComplianceSelfExcludeReportRowZod),
});
export type ComplianceSelfExcludeReportResponseType = z.TypeOf<typeof ComplianceSelfExcludeReportResponseZod>;


// #/components/schemas/complianceGamstopRequestHistoryRequest
export const ComplianceGamstopRequestHistoryRequestZod = z.object({
    accountId: z.number(),
    limit: z.number(),
    lastId: z.number().optional(),
    dateRange: ComplianceDateFilterZod,
});
export type ComplianceGamstopRequestHistoryRequestType = z.TypeOf<typeof ComplianceGamstopRequestHistoryRequestZod>;


// #/components/schemas/complianceGamstopRequestLog
export const ComplianceGamstopRequestLogZod = z.object({
    id: z.number(),
    at: z.string(),
    trace_id: z.string(),
    actor_id: z.string(),
    request_id: z.string().nullish(),
    entrypoint: z.string().nullish(),
    reason: z.string().nullish(),
    op: z.string(),
    data: z.unknown().nullish(),
});
export type ComplianceGamstopRequestLogType = z.TypeOf<typeof ComplianceGamstopRequestLogZod>;


// #/components/schemas/complianceGamstopRequests
export const ComplianceGamstopRequestsZod = z.object({
    rows: z.array(ComplianceGamstopRequestLogZod),
});
export type ComplianceGamstopRequestsType = z.TypeOf<typeof ComplianceGamstopRequestsZod>;

